//import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isVisible: false,
    user: [{nome: "Não Logado"}]
  },
  mutations: {
    toggleVisible(state, condicional) {
      if(condicional === false) {
        state.isVisible = false
      } else {
        state.isVisible = true
      }
    },

    getUser(state, value) {
      if(value) {
        state.user = value
      } else {
        state.user = [{nome: "Não Logado"}]
      }
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
  }
})
